import { keyBy } from 'lodash/fp';

import {
  fieldPathHasValidSchema,
  WorkflowValidationContext,
} from 'dashboard/lib/workflows/validation/validationContext';
import { WorkflowConfigError, WorkflowErrorType } from 'dashboard/models/workflow';
import {
  OUTPUT_STEP_TOKEN,
  outputStep,
  WorkflowVersionOutput,
} from 'dashboard/models/workflow-version';
import { ApiModel } from 'lib/interfaces/api';

export const validateOutputs = (
  outputs: WorkflowVersionOutput[] = [],
  validationContext: WorkflowValidationContext,
): WorkflowConfigError[] => {
  const { inputStep, getContextForStep } = validationContext;
  const { trigger } = inputStep;
  const stepContext = getContextForStep(OUTPUT_STEP_TOKEN);

  if (trigger?.type === ApiModel.TriggerComputedField) {
    const result = outputs?.[0]?.['method-chain'];
    if (!result) {
      return [
        {
          token: outputStep.token,
          field: 'outputs',
          message: `Result required for computed field trigger type`,
          type: WorkflowErrorType.Save,
        },
      ];
    }

    const { valid, errorMessages } = fieldPathHasValidSchema(
      result,
      stepContext,
      validationContext,
    );
    return valid
      ? []
      : [
          {
            token: outputStep.token,
            field: 'outputs',
            message: `Invalid path: ${errorMessages.join(', ')}`,
            type: WorkflowErrorType.Save,
          },
        ];
  }

  const usableObjectsByKey = keyBy('value', stepContext.usableObjects);
  const invalidOutputs = outputs.filter((output) => !usableObjectsByKey[output['method-chain']]);
  return invalidOutputs.map((output) => ({
    token: outputStep.token,
    field: `outputs.${output.token}`,
    message: `Invalid path: ${output['method-chain']}`,
    type: WorkflowErrorType.Save,
  }));
};
